export default __webpack_public_path__ + "static/media/B0_1.4f9051d5.mp3";